import { render, staticRenderFns } from "./LabelAdd.vue?vue&type=template&id=53eeb3d9&scoped=true&"
import script from "./LabelAdd.vue?vue&type=script&lang=ts&"
export * from "./LabelAdd.vue?vue&type=script&lang=ts&"
import style0 from "./LabelAdd.vue?vue&type=style&index=0&id=53eeb3d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eeb3d9",
  null
  
)

export default component.exports